import * as React from 'react';

export const useForceUpdate = (): () => void => {
	const [, setTick] = React.useState(0);
	return React.useCallback(() => {
		setTick(tick => tick + 1);
	}, []);
};